"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.LanguageName = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("../../constants");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  maxWidth: _constants.maxTextWidth,
  gap: theme.spacing(2),
  alignItems: 'center',
  flexDirection: 'column',
  flexWrap: 'wrap',
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    gap: theme.spacing(4)
  }
}));
const LanguageName = exports.LanguageName = (0, _mui.styled)('span', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  isActive
}) => ({
  ...(isActive ? {
    fontWeight: theme.typography.fontWeightBold
  } : {
    textDecoration: 'underline',
    cursor: 'pointer'
  })
}));